import { useDeliveryFlowStore } from "../../../store/newVehicleDeliveryStore";
import { CheckCircleIcon, DotCalendarIcon, LeftArrow, MapPinIcon, PhoneIcon, TrifoldMapIcon } from "../../../icons";
import { Button } from "../../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import { AlertBanner } from "../../../components/ui/AlertBanner";

export const BookingRAC = () => {

  // GLOBAL STATE: 
  const carData = useDeliveryFlowStore((s) => s.carData);

  const deliveryInfo = useDeliveryFlowStore((s) => s.deliveryStatusByPlate[carData?.vehPlate ?? carData?.plateno])
  // LOCAL STATE:
  const navigate = useNavigate();
  const availableDate = new Date(deliveryInfo?.availableFrom).toISOString().split("T")[0] ?? null

  // FETCH DATA:
 
  // LOCAL VARIABLES:

  // USE EFFECTS:
  
  // HANDLERS & FUNCTIONS:

  return (
    <div className=''>
      <div className="flex flex-row gap-2 justify-start items-start w-full pb-4 mb-10 border-b-[0.5px] border-fadedgrey lg:mr-[45px] h-min">
        <Button className='h-full pl-1' onClick={()=>{navigate(-1)}}><LeftArrow className='cursor-pointer stroke-black'/></Button>
        <DotCalendarIcon className="stroke-black w-[18px] h-[18px]"/>
        <h4 className='font-bold'>Κλείσε το ραντεβού σου</h4>
      </div>

      <div className='flex flex-col gap-6'>
        <h4>Επικοινώνησε εντός 3 εργάσιμων ημερών με τον πλησιέστερο σταθμό Avis για να προγραμματίσεις ραντεβού παραλαβής:</h4>
        <div className={`"shadow-md rounded-xl py-6 px-10 bg-white flex flex-col gap-2`}>
          <p className='text-sm font-bold'>Τοποθεσία</p>
          <div className='flex flex-row gap-1'>
            <MapPinIcon className='w-4 h-4' />
            <p className='text-sm'>{deliveryInfo?.deliveryLocation?.address}, {deliveryInfo?.deliveryLocation?.city}</p>
          </div>
          {deliveryInfo?.deliveryLocation?.phones?.length > 0 && <div className='flex flex-row gap-1'>
            <PhoneIcon className='w-4 h-4' />
            {deliveryInfo?.deliveryLocation?.phones?.map((phone, index)=> {return <p className='text-sm'>{phone}{index === deliveryInfo?.deliveryLocation?.phones?.length - 1 ? "" : ", "}</p>})}
          </div>}
          <div className='flex flex-row gap-1'>
            <DotCalendarIcon className='w-5 h-5' />
            <p className='text-sm'>Διαθέσιμο για παραλαβή από {(() => {
                const [y, m, d] = availableDate.split("-");
                return `${d}.${m}.${y}`;
              })()}</p>
          </div>
          <button 
            className='bg-none flex flex-row gap-2 border mt-2 border-fadedgrey rounded-md w-fit' 
            onClick={()=>{
              const googleMapsUrl = `https://www.google.com/maps?q=${deliveryInfo?.deliveryLocation?.coordinates?.lat},${deliveryInfo?.deliveryLocation?.coordinates?.lng}`
              window.open(deliveryInfo?.deliveryLocation?.googleMapsURL ?? googleMapsUrl, "_blank", "noopener,noreferrer");           
            }}>
              <div className='flex flex-row items-center gap-2 px-10 py-3'>
                <TrifoldMapIcon className={`w-4 h-4 `} />
                <p className={`text-sm font-semibold`}>Δες το στον χάρτη</p>
              </div>
          </button>
        </div>
        <AlertBanner severity="info" className='pb-1'>
          <div className='flex flex-row gap-[14px] justify-start align-top p-3'>
              <CheckCircleIcon width='20' height='20' className={'stroke-[#2E9BFF] shrink-0'} />
              <p className='text-sm'>Η τιμολόγηση θα ξεκινήσει εντός 3 εργάσιμων ημερών από την ημερομηνία διαθεσιμότητας του αυτοκινήτου για παραλαβή.</p>
          </div>
      </AlertBanner>
      </div>
    </div>
  );
};
